<template>
	<div class="form-group">
		<div
			:class="{'float-left': (field.labelStyle=='justify'||field.labelStyle=='inline')}"
		>
			<label v-if="field.question" class="mr-2 align-top" :for="field.id">
				{{ field.question }}
				<span class="btn btn-primary btn-xs text-sm" @click="toggleInfo" v-if="hasInfo">Show Details</span>
			</label>
            <small 
                v-if="requiredIncomplete"
                class="ml-1" style="color:#FF0000"    
            >
                {{  $t('required')}}
            </small>
			<div v-if="field.description" v-html="field.description" class="mr-2"></div>
			<div v-if="(this.viewinfo && field.info)" v-html="field.info" class="mr-2 text-sm"></div>
		</div>

		<input
			type="date"
			class="form-control"
			v-model="field.value"
			:id="field.id"
			:aria-label="field.question"
			:class="{'float-right': (field.labelStyle=='justify'),
                'requiredincomplete': requiredIncomplete
            }"
			v-bind:style="{ 'display': (field.labelStyle=='justify'||field.labelStyle=='inline'?'inline':''), 'width': (field.labelStyle=='justify'||field.labelStyle=='inline'?'auto':'') }"
			:readonly="readonly"
		>
	</div>
</template>

<script>
export default {
	props: ['field', 'readonly','viewAs'],
	data() {
		return {
			'viewinfo': false
		}
	},
	methods: {
        toggleInfo() {
        	this.viewinfo = !this.viewinfo;
        }
    },
    computed: {
        requiredIncomplete() {
        	return (this.field.permission.includes(this.viewAs) || this.field.permission.length === 0) 
        	&& this.field.required && !this.field.value && this.field.value !== 0;
        },
        hasInfo() {
        	if(this.field.info){
        		return true;
        	}
        	return false;
        }
    }
};
</script>
